import React, { useContext } from "react";
import { CommandBarButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../core/security/SprintAccessRight";
import { OrderRequestListingContext } from "../../context/OrderRequestListingContext";
import { mapToSendOrderRequestItem } from "../SendOrderRequestSummaryList";
import { SendMultipleOrderRequestsToCloudDialog } from "./SendMultipleOrderRequestsToCloudDialog";

export const SendMultipleOrderRequestsToCloudButton: React.VFC = () => {
    const { selectedItems } = useContext(OrderRequestListingContext);

    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <CommandBarButton
                text="Cloud Processing"
                icon="CloudUpload"
                testId="bulk-cloud-processing-button"
                disabled={!selectedItems.length}
                onClick={onOpen}
            />
            {isOpen && (
                <SendMultipleOrderRequestsToCloudDialog
                    key={String(isOpen)}
                    selectedItems={selectedItems.map((item) => mapToSendOrderRequestItem(item))}
                    onClose={onClose}
                />
            )}
        </AuthorizationWrapper>
    );
};
